@if (sessionFiles$ | async; as sessionFiles) {
  @if (sessionFiles.length > 0) {
    <!-- Filters -->
    <form class="file-filters form-full-width" [formGroup]="filterFields">
      <span class="filter-field" style="flex: 3">
        <mat-form-field appearance="outline">
          <mat-label>BIDS File Name</mat-label>
          <mat-icon class="xs" matPrefix>filter_alt</mat-icon>
          <input autocomplete="off" formControlName="fileName" matInput test-id="filename-filter" type="text" />
        </mat-form-field>
      </span>
      <span class="filter-field" style="flex: 2">
        <mat-form-field appearance="outline" aria-label="File Type">
          <mat-select class="muted" formControlName="fileType" test-id="file-type-filter">
            <mat-option value="">All Types</mat-option>
            @for (fileType of fileTypes; track fileType) {
              <mat-option [value]="fileType">{{ fileType }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </span>
    </form>
    <!-- Data -->
    @for (bucket of bidsBuckets$ | async; track bucket) {
      @if (bucket.files.length > 0) {
        <div>
          <div class="bucket-name">{{ bucket.label }}</div>
          @for (file of bucket.files; track file) {
            <div class="bids-file" [ngClass]="{ disabled: isQuarantined(file) }">
              <span class="file-origin">
                @if (getFileOrigin(file); as originInfo) {
                  @if (originInfo.matIcon) {
                    <mat-icon class="xs" [fwTooltip]="originInfo.popoverText">{{ originInfo.matIcon }}</mat-icon>
                  }
                }
              </span>
              <span class="file-name-version" style="flex: 3">
                <fw-ellipsis [text]="file.info?.BIDS?.Filename || file.name" />
                @if (file.version > 1) {
                  <file-version-badge class="version-badge" [file]="file" />
                }
              </span>
              <div class="file-type-actions" style="flex: 2">
                <span class="file-type">{{ file.type }}</span>
                @if (!isQuarantined(file)) {
                  <file-actions
                    [container]="fileParents.get(file)"
                    [file]="file"
                    [hoverFeatures]="$any(['view', 'info', 'download'])"
                    [kabobFeatures]="
                      $any(['info', 'download', 'delete', 'version-history', 'copy-filename', 'copy-modality', 'view'])
                    "
                    [viewParams]="fileViewParameters"
                    (afterChange)="loadFiles()"
                    (afterDelete)="loadFiles()"
                  >
                    <button action="view" class="xs" fwTooltip="View" mat-icon-button test-id="view-file">
                      <mat-icon class="xs">panorama_outline</mat-icon>
                    </button>
                    <button action="info" class="xs" fwTooltip="Information" mat-icon-button test-id="file-info">
                      <mat-icon class="xs">info</mat-icon>
                    </button>
                    <button action="download" class="xs" fwTooltip="Download" mat-icon-button test-id="download-file">
                      <mat-icon class="xs">cloud_download</mat-icon>
                    </button>
                    <button class="xs" mat-icon-button test-id="file-actions-menu">
                      <mat-icon class="xs">more_vert</mat-icon>
                    </button>
                  </file-actions>
                }
              </div>
            </div>
          }
        </div>
      }
    }
  } @else {
    <div class="info-message">
      <div class="fab">
        <mat-icon>list</mat-icon>
      </div>
      <p>There are no files in this session yet.</p>
    </div>
  }
} @else {
  @if (!error) {
    <div class="loading-state">
      <mat-progress-bar mode="buffer" />
    </div>
  } @else {
    <div class="info-message">
      <div class="fab">
        <mat-icon>error_outline</mat-icon>
      </div>
      <p>Session files could not be retrieved.</p>
      <button color="primary" mat-flat-button test-id="reload-files" (click)="loadFiles()">Reload Data</button>
    </div>
  }
}
